'use strict';

/**
 * Normalise les clés d'un objet de formulaire de simulation :
 *  - "["  -> "_"     (ex. "simulation[town]"   -> "simulation_town")
 *  - "]"  -> ""
 *  - camelCase -> snake_case ("A" -> "_a", ex. "numberOfAdult" -> "number_of_adult")
 *  - "__" -> "_"
 *
 * Comportement repris à l'identique de simulation.js (extraction) : l'objet est muté EN PLACE
 * (chaque clé d'origine renommée est recopiée puis supprimée) puis renvoyé. La liste des clés est
 * figée au début, donc chaque clé d'origine n'est traitée qu'une fois.
 *
 * @param {Object} formObject objet de formulaire (clés "simulation[xxx]")
 * @returns {Object} le même objet, avec les clés normalisées
 */
function transformKeyObject(formObject) {
    var keys = Object.keys(formObject);
    for (var j = 0; j < keys.length; j++) {
        var newKey = keys[j].replace("[", "_");
        newKey = newKey.replace("]", "");
        newKey = newKey.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
        newKey = newKey.replace("__", "_");
        if (keys[j] !== newKey) {
            formObject[newKey] = formObject[keys[j]];
            delete formObject[keys[j]];
        }
    }
    return formObject;
}

module.exports = transformKeyObject;
